'use strict';
import React, { PureComponent } from 'react';
import BotonImportarModelo from './BotonImportarModelo';
import ImportarModelosContables from './ImportarModelosContables';
import { GenericModal } from 'com-gyf-webcore-userinterfacecomponents';


class Cabecera extends PureComponent {
    constructor(props) {
        super(props);

        this.routeToModelosContables = this.routeToModelosContables.bind(this);
        this.validarGuardarModelo = this.validarGuardarModelo.bind(this);
        this.mostrarOcultarImportarModelos = this.mostrarOcultarImportarModelos.bind(this);
    }

    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    routeToModelosContables(e) {
        if (sessionStorage.getItem('PantallaCambios') == "true") {
            e.preventDefault();
            $("#cancel-modal").modal({ backdrop: "static" });
        } else {
            $("#cancel-modal").modal("hide");
            this.props.routeToModelosContables("");
        }  
    }

    onModalConfirmClick() {
        if (sessionStorage.getItem('PantallaCambios') == "true") {
            sessionStorage.removeItem('PantallaCambios')
        }
        $("#cancel-modal").modal("hide");
        this.props.routeToModelosContables("");
    }

    validarGuardarModelo(mostrarAlertaNoConfirmado) {
        if(mostrarAlertaNoConfirmado) {
            //mostrar warning
            this.props.actualizarOpcionElegida("G");  
            this.props.mostrarOcultarModalABMModelos("modalConfirmarAbandonoABMModelos", true)
        } else {
            this.props.validarGuardarModelo();
        }
    }

    mostrarOcultarImportarModelos(valor) {
        this.props.mostrarOcultarImportarModelos(valor);
    }

    render() {
        const {
            dataModeloEdicion,
            datosPantalla,
            descripcionModeloSeleccionadoImportar,
            esEdicion,
            inputImportarModelo,
            modelosFiltradosImportarModelo,
            modeloSeleccionadoImportar,
            mostrarMakerChecker,
            mostrarResultadosImportarModelo,
            permisoBotonMakerChecker,
            permisoAlta,
            permisoBaja,
            permisoModificacion,
            seImportaModelo,
            soloLectura,

        } = this.props;

        //ACTIONS
        const {
            actualizarConfirmacionModelo,
            buscarModelosImportar,
            importarModelo,
            mostrarOcultarImportarModelos,
            mostrarOcultarResultadosImportarModelos
        } = this.props;

        const descripcionModelo = dataModeloEdicion && (dataModeloEdicion.Codigo + " - " + dataModeloEdicion.Descripcion);
        const titulo = dataModeloEdicion && !permisoModificacion ? ("Modelo " + descripcionModelo) : dataModeloEdicion ? ("Edición modelo " + descripcionModelo) : "Nuevo Modelo"
        const botonAceptarHabilitado = (esEdicion && (permisoModificacion || permisoBaja)) || (!esEdicion && permisoAlta);
       
        const horaFormateada = datosPantalla && datosPantalla.length > 0 && datosPantalla[0].FechaConfirmacion != null ? datosPantalla[0].FechaConfirmacion.slice(0,16).split('T') : null ;
        const fechFormateada = datosPantalla && datosPantalla.length > 0 && datosPantalla[0].FechaConfirmacion != null ? new Date(horaFormateada[0]).toLocaleDateString('en-GB')  : null;
        const fechaHoraFormateada =datosPantalla && datosPantalla.length > 0 && datosPantalla[0].FechaConfirmacion != null ? fechFormateada + " " +  horaFormateada[1] : null;

        const mostrarAlertaNoConfirmado = mostrarMakerChecker && !datosPantalla[0].UsuarioConfirmacion && !datosPantalla[0].FechaConfirmacion && permisoBotonMakerChecker;

        return (
            <div className="seccionCabecera">
                <div className="seccionCabecera__contenedorTitulo AsientosContables--overflowHidden">
                    <div className="TituloPrincipal AsientosContables--floatLeft">
                        {titulo}
                        {soloLectura && esEdicion ?
                            <span className="seccionCabecera__soloLectura">(Solo lectura)</span>
                            :
                            null
                        }
                    </div>

                    {!esEdicion && !seImportaModelo ?
                        <BotonImportarModelo
                            mostrarOcultarImportarModelos={mostrarOcultarImportarModelos}
                        />
                        :
                        null
                    }

                    {seImportaModelo ? 
                        <ImportarModelosContables
                            buscarModelosImportar={buscarModelosImportar}
                            importarModelo={importarModelo}
                            mostrarOcultarImportarModelos={mostrarOcultarImportarModelos}
                            mostrarOcultarResultadosImportarModelos={mostrarOcultarResultadosImportarModelos}

                            descripcionModeloSeleccionadoImportar={descripcionModeloSeleccionadoImportar}
                            mostrarResultadosImportarModelo={mostrarResultadosImportarModelo}
                            inputImportarModelo={inputImportarModelo}
                            modelosFiltradosImportarModelo={modelosFiltradosImportarModelo}
                            modeloSeleccionadoImportar={modeloSeleccionadoImportar}
                            nombreInput={"inputImportarModelo"}
                        />
                    :
                        null
                    }
                </div>

                {mostrarMakerChecker ?
                        datosPantalla[0].UsuarioConfirmacion && datosPantalla[0].FechaConfirmacion ?
                        <div className="seccionCabecera__contenedorTitulo AsientosContables--overflowHidden seccionCabecera_heightModeloNoConfirmado">
                               <div className="ABMModelos--overflowHidden">
                                   <div className='ABMModelos--floatLeft contenedor-icon-confirmado'>
                                       <label className="icon-confirmado-tilde"></label>
                                   </div>
   
                                   <div className="ABMModelos--floatLeft ABMModelos__labelDescripcionConfirmacionConfirmado">Modelo confirmado por {datosPantalla[0].UsuarioConfirmacion} el {fechaHoraFormateada} </div>
   
                               </div>
                            </div>
                            :
                            <div className="seccionCabecera__contenedorTitulo AsientosContables--overflowHidden">
                                        <div className='ABMModelos--floatLeft contenedor-icon-denegado'>
                                    <label className="icon-denegado-tilde"></label>
                                </div>
                                        <div className="ABMModelos--floatLeft ABMModelos__labelDescripcionConfirmacion">Modelo no confirmado</div>
                                    {permisoBotonMakerChecker ? 
                                          <div className="ABMModelos--floatLeft">
                                            <label className="icon-confirmado iconosNovedades botonConfirmarModificacionCampo" onClick={actualizarConfirmacionModelo}>
                                                <span className="ABMModelos-labelConfirmar">Confirmar</span>
                                            </label> 
                                        
                                          </div>
                                        :
                                          null
                                        }
                                    </div>
                        :
                        null                        
                    }
                
                <div className="Tarjetas-contenedor-boton-aceptar-cancelar">
                    <div className="seccionCabecera__contenedorBotones">
                        <div className="seccionCabecera__contenedorBotones--float">
                            <button className={"seccionCabecera__botonAceptar" + (botonAceptarHabilitado ? "" : " ABMModelosModalContainer__botonAceptar--deshabilitado")} onClick={() => botonAceptarHabilitado ? this.validarGuardarModelo(mostrarAlertaNoConfirmado) : null} >
                                Guardar
                            </button>   
                        </div>
                        <div className="seccionCabecera__contenedorBotones--float">
                            <button className="seccionCabecera__botonCancelar" onClick={(e) => this.routeToModelosContables(e)} >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>

                <div className="lineaDivisoria"></div>
                <GenericModal id="cancel-modal"
                    className="modal fade-out modal-center"
                    type="ALL_CUSTOM"
                    screenSize="modal-dialog modal-generic"
                    header={<h2 className="modal-title">Descartar Cambios</h2>}
                    footer={<div className="row">
                        <div className="col-xs-5">
                            <button type="button" className="btn btn-cta" onClick={() => this.onModalConfirmClick()}>Descartar Cambios</button>
                        </div>
                        <div className="col-xs-7">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        </div>
                    </div>}
                    body={<p>Se han realizado modificaciones, en caso de no guardarlos se perderán ¿Desea descartar los cambios?</p>}
                />
            </div>
        );
    }
}

export default Cabecera;